import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
} from '@angular/core';
import {NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {OneLineObjectComponent} from './one-line-object.component';
import {POOrganization} from '@objects-module/model';

@Component({
  selector: 'app-one-line-org-unit',
  template: `
    <app-org-unit-list-control
      [formControl]="objectListControl"
      [parentId]="newObjParentId"
      [maxCount]="1"
      [showOwner]="showOwner"
      [customStyle]="customStyle"
      [setMatAutocomplete]="true"
      [canFilter]="canFilter"
      [label]="label"
      [isRequired]="isRequired"
      [organization]="organization"
      [isLoading]="isLoading"
    >
    </app-org-unit-list-control>
  `,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => OneLineOrgUnitComponent),
      multi: true,
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => OneLineOrgUnitComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OneLineOrgUnitComponent extends OneLineObjectComponent {
  @Input() organization?: number | null = null;
  constructor() {
    super();
  }
}
